/**
 * One EventSource per page for the booking engine's live revision push.
 * The wizard (step 2/3) and the hub summary (step 1) both need it; opening two
 * connections to the same shop would double the server's stream fan-out.
 */
(function (global) {
  'use strict';
  if (global.WorkshopLiveStream) return;

  var FALLBACK_URL = 'https://amc-ew.aogen.com.au/api/public/workshop-city/event-live-stream';
  var MAX_PRE_HELLO_FAILS = 5;

  var subscribers = [];
  var source = null;
  var gotHello = false;
  var fails = 0;
  var streamOk = false;
  var lifecycleBound = false;

  function shopDomain() {
    return global.Shopify && global.Shopify.shop ? String(global.Shopify.shop) : '';
  }

  function endpointUrl() {
    var API = global.WorkshopCityEvents;
    if (API && API.LIVE_STREAM_URL) return String(API.LIVE_STREAM_URL);
    if (API && typeof API.resolveLiveStreamUrl === 'function') {
      var fromApi = API.resolveLiveStreamUrl();
      if (fromApi) return String(fromApi);
    }
    if (global.document) {
      var explicit = global.document.querySelector('[data-live-stream-api-url]');
      if (explicit) {
        var attr = explicit.getAttribute('data-live-stream-api-url');
        if (attr) return String(attr).trim();
      }
      var eventsEl = global.document.querySelector('[data-events-api-url]');
      var eventsUrl = eventsEl ? String(eventsEl.getAttribute('data-events-api-url') || '').trim() : '';
      if (eventsUrl) return eventsUrl.replace(/\/events\/?$/, '/event-live-stream');
    }
    return FALLBACK_URL;
  }

  function parsePayload(e) {
    if (!e || e.data == null || e.data === '') return {};
    try {
      var parsed = JSON.parse(e.data);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_) {
      return {};
    }
  }

  function emit(type, payload) {
    var at = Date.now();
    var body = payload && typeof payload === 'object' ? payload : {};
    subscribers.slice().forEach(function (fn) {
      try {
        fn({ type: type, at: at, payload: body, scope: body.scope });
      } catch (_) {}
    });
  }

  function closeSource() {
    if (!source) return;
    try {
      source.close();
    } catch (_) {}
    source = null;
    streamOk = false;
  }

  function open() {
    if (source || typeof EventSource === 'undefined') return false;
    var shop = shopDomain();
    if (!shop) return false;
    var url = endpointUrl() + '?shop_domain=' + encodeURIComponent(shop);
    var es;
    try {
      es = new EventSource(url);
    } catch (_) {
      return false;
    }
    source = es;
    gotHello = false;
    fails = 0;
    es.addEventListener('hello', function (e) {
      gotHello = true;
      fails = 0;
      streamOk = true;
      emit('hello', parsePayload(e));
    });
    es.addEventListener('live', function (e) {
      emit('live', parsePayload(e));
    });
    es.addEventListener('catalog', function (e) {
      emit('catalog', parsePayload(e));
    });
    es.onerror = function () {
      streamOk = false;
      fails += 1;
      emit('error');
      // Give up only when the browser itself closed the stream (it will not retry)
      // or after repeated pre-hello failures. Transient blips keep auto-reconnecting.
      var browserClosed = typeof EventSource !== 'undefined' && es.readyState === EventSource.CLOSED;
      if (browserClosed || (!gotHello && fails >= MAX_PRE_HELLO_FAILS)) {
        if (source === es) closeSource();
      }
    };
    return true;
  }

  function ensureHealthy() {
    if (!subscribers.length || typeof EventSource === 'undefined') return;
    if (source && source.readyState !== EventSource.CLOSED) return;
    closeSource();
    open();
  }

  function bindLifecycleOnce() {
    if (lifecycleBound || !global.document) return;
    lifecycleBound = true;
    global.document.addEventListener('visibilitychange', function () {
      if (!global.document.hidden) ensureHealthy();
    });
    global.addEventListener('pageshow', function (e) {
      if (e && e.persisted) ensureHealthy();
    });
    global.addEventListener('pagehide', function () {
      closeSource();
    });
  }

  function subscribe(fn) {
    if (typeof fn !== 'function') return function () {};
    subscribers.push(fn);
    bindLifecycleOnce();
    if (subscribers.length === 1) open();
    else if (streamOk) {
      // Late subscriber joins an already-open stream: replay hello so it can
      // pause its own polling fallback immediately.
      try {
        fn({ type: 'hello', at: Date.now(), payload: {}, scope: undefined });
      } catch (_) {}
    }
    var done = false;
    return function unsubscribe() {
      if (done) return;
      done = true;
      var i = subscribers.indexOf(fn);
      if (i !== -1) subscribers.splice(i, 1);
      if (!subscribers.length) closeSource();
    };
  }

  global.WorkshopLiveStream = {
    subscribe: subscribe,
    ensureHealthy: ensureHealthy,
    isOk: function () {
      return streamOk;
    },
    isSupported: function () {
      return typeof EventSource !== 'undefined';
    },
    endpointUrl: endpointUrl,
  };
})(typeof window !== 'undefined' ? window : this);
